<template>
  <b-overlay :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm">
    <validation-observer ref="articleTypeForm">
      <b-form @submit.prevent=""
        @reset.prevent="resetForm">
        <validation-provider #default="validationContext"
          vid="code"
          name="Mã"
          rules="required">
          <b-form-group>
            <template #label>
              <label class="d-block font-weight-bolder pb-0">Mã <span class="text-danger">*</span></label>
            </template>
            <b-form-input id="code"
              v-model="frmData.code"
              :state="getValidationState(validationContext)"
              placeholder="Nhập..." />
            <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <validation-provider #default="validationContext"
          vid="name"
          name="Tên thể loại"
          rules="required">
          <b-form-group>
            <template #label>
              <label class="d-block font-weight-bolder pb-0">Tên thể loại <span class="text-danger">*</span></label>
            </template>
            <b-form-input id="name"
              v-model="frmData.name"
              :state="getValidationState(validationContext)"
              placeholder="Nhập..." />
            <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <b-form-group label="Mô tả"
          label-for="textarea">
          <b-form-textarea id="textarea"
            v-model="frmData.desc"
            placeholder="Nhập mô tả..."
            rows="2" />
        </b-form-group>
        <b-form-checkbox v-model="frmData.status"
          vid="kaka"
          value="1"
          class="custom-control-primary"> Kích hoạt </b-form-checkbox>
        <div class="d-flex mt-2">
          <b-button variant="primary"
            type="submit"
            @click.prevent="validationForm"> {{ $t('Save') }}</b-button>
        </div>
      </b-form>
    </validation-observer>
  </b-overlay>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BAlert,
  BOverlay,
  BForm,
  BFormGroup,
  BButton,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormTextarea,
  BCardText,
} from 'bootstrap-vue';
import { required, email, alphaNum, min, max, } from '@validations'
import { ref, reactive } from '@vue/composition-api';
import store from '@/store';
import { useRouter, showToast } from '@core/utils/utils';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import formValidation from '@core/comp-functions/forms/form-validation';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BAlert,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    dataEdit: {
      type: Object,
      default: null
    },
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const loading = ref(false);
    const blankData = {
      name: '',
      code: '',
      desc: '',
      status: 1,
    }
    const frmData = ref(JSON.parse(JSON.stringify(blankData)))
    const resetfrmData = () => {
      frmData.value = JSON.parse(JSON.stringify(blankData))
    }
    if (Object.keys(props.dataEdit).length > 0) {
      frmData.value = props.dataEdit
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(frmData)


    return {
      loading,
      frmData,
      refFormObserver,
      resetForm,
      getValidationState,
      resetfrmData,
    };
  },
  methods: {
    onSubmit() {

      if (this.frmData.id) {
        let id = this.frmData.id;
        store.dispatch('articletype/update', { data: this.frmData, id })
          .then(response => {
            const result = response.data;
            if (result.code === 200) {
              showToast(result.message, { variant: 'success' });
              this.$emit('updateList');
              this.resetfrmData()
            } else {
              if (result.errors) {
                this.$refs.articleTypeForm.setErrors(result.errors);
              } else {
                showToast(result.message);
              }
            }
          })
      } else {
        store.dispatch('articletype/create', this.frmData)
          .then(response => {
            const result = response.data;
            if (result.code === 200) {
              showToast(result.message, { variant: 'success' });
              this.$emit('updateList');
              this.resetfrmData()
            } else {
              if (result.errors) {
                this.$refs.articleTypeForm.setErrors(result.errors);
              } else {
                showToast(result.message);
              }
            }
          })
      }
    },
    validationForm() {
      this.errorMessage = {}
      this.$refs.articleTypeForm.validate().then(success => {
        if (success) {
          this.onSubmit();
        }
      })
    },
  }
};
</script>

